import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
  title = "Algoarts - IT Consulting and Software Development Services | Turning Ideas into Digital Reality",
  description = "Algoarts is a leading software development company in Sri Lanka, providing custom software solutions, web development, AI/ML services, and cloud solutions to clients worldwide.",
  keywords = "Algoarts, software development company, IT consulting, custom software development, web development, mobile app development, AI machine learning, cloud solutions",
  image = "https://algoarts.tech/logo192.png",
  url = "https://algoarts.tech",
  type = "website",
  structuredData = null
}) => {
  const fullTitle = title.includes('Algoarts') ? title : `${title} | Algoarts`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={fullTitle} />
      
      {/* Structured Data */}
      {structuredData && (
        Array.isArray(structuredData) ? (
          structuredData.map((data, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(data)}
            </script>
          ))
        ) : (
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        )
      )}
    </Helmet>
  );
};

export default SEO;

